import React from "react";

export default function InputField({ label, type, placeholder, value, onChange, errorMsg, inputClass, controlClass, disabled, accept }) {
	return (
		<div className="field mb-4">
			<label className="label">{label}</label>
			<div className={"control " + controlClass}>
				<input
					className={"input is-hovered " + inputClass}
					type={type}
					placeholder={placeholder}
					onChange={onChange}
					value={value}
					disabled={disabled}
					accept={accept}
				/>
			</div>
			<p className="help is-danger">{errorMsg}</p>
		</div>
	);
}
